<template>
  <a-modal v-model:visible="logVisible" title="操作记录" :footer="null">
    <div style="height: 420px;">
      <a-table
        v-if="logList && logList.length > 0"
        :dataSource="logList"
        :columns="logColumns"
        :scroll="{ y: 300 }"
        :pagination="false"
        class="mb40"
      >
      </a-table>
      <div style="display: flex; flex-direction: row; float: right;">
        <a-pagination
          v-if="logList && logList.length > 0"
          class="mr20"
          v-model:current="logPagination.pageNum"
          :total="logPagination.total"
          v-model:pageSize="logPagination.pageSize"
          :showTotal="false"
          :showSizeChanger="false"
          @change="col_queryColLog_post"
        />
      </div>
    </div>
  </a-modal>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState')),
      logColumns: [
        {
          title: '同步人',
          dataIndex: 'operatorName',
          key: 'operatorName',
          align: 'center'
        },
        {
          title: '同步时间',
          dataIndex: 'operatorTime',
          key: 'operatorTime',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'logContent',
          key: 'logContent',
          align: 'center'
        }
      ]
    }
  }
}
</script>
